import api from './api.ts';

export type PhilanthropyCategory = 'education' | 'health' | 'environment' | 'other';

export interface Philanthropy {
  id: string;
  description: string;
  category: PhilanthropyCategory;
  amount: number;
  donatedAmount?: number;
  availableAmount?: number;
  donationDate?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface PhilanthropyPayload {
  description: string;
  category: PhilanthropyCategory;
  amount: number;
  donationDate?: string | null;
}

export interface PhilanthropyDonationPayload {
  date: string;
  amount: number;
  description?: string | null;
}

const basePath = '/philanthropies';

export const PhilanthropiesAPI = {
  async list(): Promise<Philanthropy[]> {
    const { data } = await api.get(basePath);
    return data;
  },

  async get(id: string): Promise<Philanthropy> {
    const { data } = await api.get(`${basePath}/${id}`);
    return data;
  },

  async create(payload: PhilanthropyPayload): Promise<Philanthropy> {
    const { data } = await api.post(basePath, payload);
    return data;
  },

  async update(id: string, payload: PhilanthropyPayload): Promise<Philanthropy> {
    const { data } = await api.put(`${basePath}/${id}`, payload);
    return data;
  },

  async remove(id: string): Promise<void> {
    await api.delete(`${basePath}/${id}`);
  },

  async listDonations(id: string): Promise<any[]> {
    const { data } = await api.get(`${basePath}/${id}/donations`);
    return data;
  },

  async addDonation(id: string, payload: PhilanthropyDonationPayload): Promise<Philanthropy> {
    const { data } = await api.post(`${basePath}/${id}/donations`, payload);
    return data;
  },

  async updateDonation(
    id: string,
    donationId: string,
    payload: Partial<PhilanthropyDonationPayload>
  ): Promise<Philanthropy> {
    const { data } = await api.put(`${basePath}/${id}/donations/${donationId}`, payload);
    return data;
  },

  async deleteDonation(id: string, donationId: string): Promise<Philanthropy> {
    const { data } = await api.delete(`${basePath}/${id}/donations/${donationId}`);
    return data;
  },
};

export default PhilanthropiesAPI;
